export const applyOptions = {
  PERIOD_USING_CELLPHONE: "/dl/periodUsingCellPhone",
  HOUSING_SITUATION: "/dl/housingSituation",
  REASONS_FOR_LOAN: "/dl/reasonsForLoan",
  STATES: "/v6/nationality/countries/countryId/:stateCode/states"
};

export const request = {
  AUTHORIZE: "/dl/loanRequestForm/authorize",
  INDEXED_BORROWER: "/api/dl/indexedBorrower",
  INDEXED_BORROWER_EXTRAS: "/api/dl/indexedBorrowerExtras",
  LOAN_REQUEST: "/api/dl/loanRequest",
  LOAN_REQUESTS: "/api/dl/loanRequests",
  LOAN_REQUESTS_DOC: "/dl/loanRequests/:referenceId/documents",
  LOAN_REFERENCE: "/dl/loanRequests/:referenceId",
  ACQUISITION_PARTNER: "/dl/no-integration/acquisition-partners/:alias",
  LOAN_REQUESTS_ACQUISITION_PARTNER: "/dl/no-integration/loan-requests",
  BANK_STATEMENT_UPLOAD_URL: "/dl/bank-statement-transactions/upload/:referenceId/loan-requests",
};